// extracted by mini-css-extract-plugin
export default {"DeleteClientHealthChecksDialog":"DeleteClientHealthChecksDialog_DeleteClientHealthChecksDialog__Dsgwu"};